import {
  getGroupsData,
  getShopsData,
  getMenuGenre,
  getMenuSituation,
  getMenuUserTarget,
  getShopsGochiKidData,
  getMenusGochiKidData,
  getGroupsSpecialGochiKidData,
  getShopsGroupSpecialGochiKidData,
  getDonateHistoryGochiKidData
} from '../libs/apis/OptionApi';

export const GET_GROUPS_REQUEST = 'GET_GROUPS_REQUEST';
export const GET_GROUPS_SUCCESS = 'GET_GROUPS_SUCCESS';
export const GET_GROUPS_FAILURE = 'GET_GROUPS_FAILURE';

export const GET_SHOPS_REQUEST = 'GET_SHOPS_REQUEST';
export const GET_SHOPS_SUCCESS = 'GET_SHOPS_SUCCESS';
export const GET_SHOPS_FAILURE = 'GET_SHOPS_FAILURE';

export const GET_MENU_GENRE_REQUEST = 'GET_MENU_GENRE_REQUEST';
export const GET_MENU_GENRE_SUCCESS = 'GET_MENU_GENRE_SUCCESS';
export const GET_MENU_GENRE_FAILURE = 'GET_MENU_GENRE_FAILURE';

export const GET_MENU_SITUATION_REQUEST = 'GET_MENU_SITUATION_REQUEST';
export const GET_MENU_SITUATION_SUCCESS = 'GET_MENU_SITUATION_SUCCESS';
export const GET_MENU_SITUATION_FAILURE = 'GET_MENU_SITUATION_FAILURE';

export const GET_MENU_USER_TARGET_REQUEST = 'GET_MENU_USER_TARGET_REQUEST';
export const GET_MENU_USER_TARGET_SUCCESS = 'GET_MENU_USER_TARGET_SUCCESS';
export const GET_MENU_USER_TARGET_FAILURE = 'GET_MENU_USER_TARGET_FAILURE';

export const GET_SHOPS_GOCHI_KID_REQUEST = 'GET_SHOPS_GOCHI_KID_REQUEST';
export const GET_SHOPS_GOCHI_KID_SUCCESS = 'GET_SHOPS_GOCHI_KID_SUCCESS';
export const GET_SHOPS_GOCHI_KID_FAILURE = 'GET_SHOPS_GOCHI_KID_FAILURE';

export const GET_MENUS_GOCHI_KID_REQUEST = 'GET_MENUS_GOCHI_KID_REQUEST';
export const GET_MENUS_GOCHI_KID_SUCCESS = 'GET_MENUS_GOCHI_KID_SUCCESS';
export const GET_MENUS_GOCHI_KID_FAILURE = 'GET_MENUS_GOCHI_KID_FAILURE';

export const GET_GROUPS_SPECIAL_GOCHI_KID_REQUEST =
  'GET_GROUP_SPECIAL_GOCHI_KID_REQUEST';
export const GET_GROUPS_SPECIAL_GOCHI_KID_SUCCESS =
  'GET_GROUP_SPECIAL_GOCHI_KID_SUCCESS';
export const GET_GROUPS_SPECIAL_GOCHI_KID_FAILURE =
  'GET_GROUP_SPECIAL_GOCHI_KID_FAILURE';

export const GET_SHOPS_GROUP_SPECIAL_GOCHI_KID_REQUEST =
  'GET_SHOPS_GROUP_SPECIAL_GOCHI_KID_REQUEST';
export const GET_SHOPS_GROUP_SPECIAL_GOCHI_KID_SUCCESS =
  'GET_SHOPS_GROUP_SPECIAL_GOCHI_KID_SUCCESS';
export const GET_SHOPS_GROUP_SPECIAL_GOCHI_KID_FAILURE =
  'GET_SHOPS_GROUP_SPECIAL_GOCHI_KID_FAILURE';

export const GET_DONATE_HISTORY_GOCHI_KID_REQUEST =
  'GET_DONATE_HISTORY_GOCHI_KID_REQUEST';
export const GET_DONATE_HISTORY_GOCHI_KID_SUCCESS =
  'GET_DONATE_HISTORY_GOCHI_KID_SUCCESS';
export const GET_DONATE_HISTORY_GOCHI_KID_FAILURE =
  'GET_DONATE_HISTORY_GOCHI_KID_FAILURE';

export const getOptionGroups = params => dispatch => {
  dispatch({ type: GET_GROUPS_REQUEST });
  return getGroupsData(params)
    .then(response =>
      dispatch({
        type: GET_GROUPS_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_GROUPS_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getOptionShops = params => dispatch => {
  dispatch({ type: GET_SHOPS_REQUEST });
  return getShopsData(params)
    .then(response =>
      dispatch({
        type: GET_SHOPS_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_SHOPS_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getMenuGenreOption = params => dispatch => {
  dispatch({ type: GET_MENU_GENRE_REQUEST });
  return getMenuGenre(params)
    .then(response =>
      dispatch({
        type: GET_MENU_GENRE_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_MENU_GENRE_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getMenuSituationOption = params => dispatch => {
  dispatch({ type: GET_MENU_SITUATION_REQUEST });
  return getMenuSituation(params)
    .then(response =>
      dispatch({
        type: GET_MENU_SITUATION_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_MENU_SITUATION_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getMenuUserTargetOption = params => dispatch => {
  dispatch({ type: GET_MENU_USER_TARGET_REQUEST });
  return getMenuUserTarget(params)
    .then(response =>
      dispatch({
        type: GET_MENU_USER_TARGET_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_MENU_USER_TARGET_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getShopsGochiKid = params => dispatch => {
  dispatch({ type: GET_SHOPS_GOCHI_KID_REQUEST });
  return getShopsGochiKidData(params)
    .then(response =>
      dispatch({
        type: GET_SHOPS_GOCHI_KID_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_SHOPS_GOCHI_KID_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getMenusGochiKid = params => dispatch => {
  dispatch({ type: GET_MENUS_GOCHI_KID_REQUEST });
  return getMenusGochiKidData(params)
    .then(response =>
      dispatch({
        type: GET_MENUS_GOCHI_KID_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_MENUS_GOCHI_KID_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getGroupsSpecialGochiKid = params => dispatch => {
  dispatch({ type: GET_GROUPS_SPECIAL_GOCHI_KID_REQUEST });
  return getGroupsSpecialGochiKidData(params)
    .then(response =>
      dispatch({
        type: GET_GROUPS_SPECIAL_GOCHI_KID_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_GROUPS_SPECIAL_GOCHI_KID_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getShopsGroupSpecialGochiKid = (
  gochiKidGroupId,
  params
) => dispatch => {
  dispatch({ type: GET_SHOPS_GROUP_SPECIAL_GOCHI_KID_REQUEST });
  return getShopsGroupSpecialGochiKidData(gochiKidGroupId, params)
    .then(response =>
      dispatch({
        type: GET_SHOPS_GROUP_SPECIAL_GOCHI_KID_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_SHOPS_GROUP_SPECIAL_GOCHI_KID_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getDonateHistoryGochiKid = (
  gochiKidGroupId,
  params
) => dispatch => {
  dispatch({ type: GET_DONATE_HISTORY_GOCHI_KID_REQUEST });
  return getDonateHistoryGochiKidData(gochiKidGroupId, params)
    .then(response =>
      dispatch({
        type: GET_DONATE_HISTORY_GOCHI_KID_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_DONATE_HISTORY_GOCHI_KID_FAILURE,
        payload: error.response,
        error: true
      })
    );
};
